const en = {
  copyLink: 'Copy link',
  copied: 'Copied!',
  share: 'Share',
  description: 'Description',
  hrText: 'People Management',
  productText: 'Product Management',
  usage: 'Examples of use',
  mentionedIn: 'This bias answers to the following questions',
  productValue: 'Product value',
  usageUiUx: 'Example of use by UI/UX',
  usageHr: 'Example of use by HR',
  managementValue: 'Management value',
  answersLabel: 'Possible answers',
  relatedQuestionsLabel: 'Related questions',
  uxeducationButtonLabel: 'Using UXCG in Education',
  downloadButtonLabel: 'Download PDF',
  visualExample: 'Visual Example',
  offsecText: 'Offensive Cybersecurity',
  offsecShortText: 'OffSec',
  usageOffsec: 'Example of use by Offensive Cybersecurity',
  offsecComingSoon:
    'Offensive Cybersecurity use cases — coming soon. We are curating attacker-side and defender-side scenarios for every bias in UX Core.',
  nextLabel: 'Next',
  prevLabel: 'Previous',
};
export default en;
